import clsx from "clsx";
import { BackIcon } from "@/components/RFIcon";

interface SelectWrapperProps {
	placeholder?: string;
	text?: string;
	style?: React.CSSProperties;
	labelLeft?: React.ReactNode | string;
	onClick?: () => void;
	disabled?: boolean;
}

export default function SelectHolder({
	text,
	style,
	labelLeft,
	onClick,
	placeholder = "请选择",
	disabled,
}: SelectWrapperProps) {
	return (
		<div
			className={clsx(
				"flex h-12 items-center rounded-full py-3 pl-5 pr-5 font-bold",
				disabled ? "rf-select-normal" : "rf-select-normal__active",
			)}
			style={{ ...style }}
			onClick={() => onClick && onClick()}
		>
			<div className="mr-4 flex flex-1 items-center">
				{labelLeft}
				{text ? <span className="font-semibold">{text}</span> : <span className="c3_85_text">{placeholder}</span>}
			</div>

			{disabled ? null : <BackIcon strokeWidth={2} className="text-c3c3c3 dark:text-858585/80 -rotate-90 w-3.5 mt-1" />}
		</div>
	);
}
